import React from "react";

import clsx from "clsx";

interface Props<T> {
  options: { label: string; value: T }[];
  value: T;
  disabled: boolean;
  onChange: (value: T) => void;
}

export const ButtonGroup = <T extends string>({
  options,
  value,
  disabled,
  onChange,
}: Props<T>) => {
  return (
    <div className="inline-flex h-10 text-sm">
      {options.map((option) => (
        <div
          key={option.value}
          className={clsx(
            "flex items-center justify-center",
            "border mr-[-1px] px-4 first:rounded-l-md last:rounded-r-md",
            {
              "bg-white hover:bg-cosmic-4 hover:border-cosmic+1 hover:z-[1]":
                option.value !== value && !disabled,
              "bg-cosmic text-white border-cosmic z-[1]":
                option.value === value && !disabled,
              "cursor-pointer": !disabled,
              "text-gray+1": option.value !== value && disabled,
              "bg-gray text-white": option.value === value && disabled,
            },
          )}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </div>
      ))}
    </div>
  );
};
